var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:['bind', _vm.row.is_bind === 1 ? 'success' : 'error']},[_vm._v(_vm._s(_vm.row.is_bind === 1 ? '已' : '未')+"绑定")])])
}
var staticRenderFns = []

export { render, staticRenderFns }